import axios from 'axios';

import { enviroments } from 'utils';

const api = axios.create({
    baseURL: enviroments.BASE_URL,
});

export default api;
